import React, { useState, useEffect, useRef } from "react"
import { Progress } from '@geist-ui/react'

const WorkoutCooldown = (props) => {
  
  const total = props.burner ? 180 : 300

  const [num, setNum] = useState(total)
  const [paused, setPaused] = useState()
  const [roundtotal, setRoundTotal] = useState(0)
  
  let intervalRef = useRef(); 

  const decreaseNum = () => {
    setNum((prev) => prev > 0 ? prev - 1 : 0);
    if(num >= 1) {
      setRoundTotal((prev) => prev < total ? prev + 1 : total);
    }
    else {
      if(props.burner) {
        props.onChange();
      }
    }
  }

  useEffect(() => {
     if(num >= 0 && !paused) {
       intervalRef.current = setInterval(decreaseNum, 1000);
     }
     else {
       clearInterval(intervalRef.current);
     }
      return () => {
        clearInterval(intervalRef.current);
      }
    }, [num, paused]);



  return (<>
    <Progress value={roundtotal} max={total} />
    <h1 className="seconds cooldown" onClick={() => setPaused(!paused)}>{Math.floor((total - roundtotal) /60)}:{(total - roundtotal) % 60 < 10 ? '0' + (total - roundtotal) % 60 : (total - roundtotal) % 60}</h1>
    </>
  )
}

export default WorkoutCooldown
